import type { ReactNode } from 'react'

import { Navigate } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { Spinner } from '@/components/ui'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isSignedIn, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/signin" replace />
  }

  return <>{children}</>
}
